const UPDATE_LAST_PAGE = 'UPDATE_LAST_PAGE'

export default {
    namespaced: true,

    state: {
        lastPage: null,
    },

    getters: {
        lastPage(state) {
            return state.lastPage
        },
    },

    mutations: {
        [UPDATE_LAST_PAGE](state, page) {
            state.lastPage = page
        },
    },

    actions: {
        updateLastPage({ commit }, page) {
            commit(UPDATE_LAST_PAGE, page)
        },
    },
}
